import { React, Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import "./header.component.css";
import LangSwitchContainer from "../languange/language.component";
import ProfileContainer from "../userprofile/userprofile.component";
import userimage from "../../../../../../src/img//Avatar.png";
import ATEMLogo from "../../../../../../src/img/ATEM-LOGO-White@2x.png";
import AccentureLogo from "../../../../../../src/img/Accenture-Logo-white@2x.png";
import Icons from "../../../icon";
import UserLanguageModal from "../../../../components/common/modal-popover/language-modal.component";
import SessionExpModal from "../../modal-popover/session-expired-modal.component";
import DataPrivacyForm from "../../modal-popover/data-privacy.component";
import Translation from "../../../common/translation/translation.component";
import { LOGIN_STATUS as loginStat } from "../../../../utils/constant.utils";
import HeaderNotification from "./notification/notification.component";
import { notificationActions } from "../../../../store/common/header-navigation/header/notification.reducer";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleProfile: false,
            langVisible: false,
            showDelModal: false,
            showErrorModal: false,
            notifId: 0,
            delModalMessage: '',
        };
    }

    componentDidMount() {
        this.props.connectHeaderNotification();
    }

    toggleProfile = (isToggle) => {
        this.setState({
            toggleProfile: isToggle ?? !this.state.toggleProfile
        });
    }

    langFunction = () => {
        this.setState({
            langVisible: !this.state.langVisible
        });
    }

    redirectToDashboard = () => {
        let dealName = sessionStorage.getItem('DealName');
        let loginStatus = sessionStorage.getItem('logInStatus');

        if (loginStatus === loginStat.external) {
            window.location.replace('/external/' + dealName + '/Dashboard');
        }
    }


    toggleNotif = (isToggle) => {
        const { hasUnreadHeaderNotification, showHeaderNotificationModal } = this.props.notification;
    
        const { toggleHeaderNotificationModal } = this.props;

        if (typeof isToggle === 'object') {
             isToggle = null; 
         }
    
        const isShow = isToggle ?? !showHeaderNotificationModal;

        if (isShow && hasUnreadHeaderNotification) {
            this.props.markAsReadHeaderNotification();
        }

        toggleHeaderNotificationModal(isShow);
    }

    ToggleLangVisible(isVisible) {
        this.setState({
            langVisible: isVisible
        })
    }

    render() {
        const { langVisible, toggleProfile, showDelModal, showErrorModal, delModalMessage } = this.state;
        const { isUserLoggedIn, notification } = this.props;
    
        return (
            <>
                {langVisible && isUserLoggedIn ?
                    <LangSwitchContainer
                        onClose={() => this.ToggleLangVisible(false)}
                        navToggle={langVisible}
                    />
                    : ""}
                {isUserLoggedIn && <DataPrivacyForm />}
                {isUserLoggedIn && <SessionExpModal />}
                {isUserLoggedIn && <UserLanguageModal />}


                <div className="external-header-nav">
                    <div className="external-header-left-nav">
                        <div className="external-header-left-nav-container">
                            <img src={AccentureLogo} className="main-logo" alt="accenture" onClick={this.redirectToDashboard} />
                            <div className="vertical-line"></div>
                            <span className="sub-logo" onClick={this.redirectToDashboard} >
                                Accenture Technology Expense Management
                            </span>
                        </div>
                    </div>
                    <div className="external-header-right-nav">
                        <div className="external-header-right-nav-container">
                            <div className="external-header__notification">
                                {
                                    notification.showHeaderNotificationModal &&
                                    <HeaderNotification
                                        data={notification.header}
                                        onClose={() => this.toggleNotif(false)}
                                    />
                                }
                                {
                                    notification.hasUnreadHeaderNotification &&
                                    <Icons
                                        customClassName="icon-header-check-reg"
                                        name="circle-exlamation-warning"
                                        size="19px"
                                        containerClass="icon-header-exlamation__container"
                                        onClick={this.toggleNotif}
                                    />
                                }
                                <Icons name="bell" size="18px" customClassName="icon-nav" onClick={this.toggleNotif} />
                            </div>

                            <Icons
                                name="globe"
                                size="18px"
                                customClassName="icon-nav"
                                labelValue={<Translation translationKey="language_code" />}
                                containerClass="right-nav-language"
                                onClick={this.langFunction}
                            />
                            <Icons
                                name="sort-down-solid"
                                size="12px"
                                containerClass="right-nav-icon-dropdown"
                                onClick={this.langFunction}
                            />
                            <div className="vertical-line"></div>
                            <div className="right-nav-profile" onClick={this.toggleProfile}>
                                <img src={userimage} alt="Avatar" className="cover-profile-image" />
                            </div>
                            {
                                toggleProfile &&
                                <ProfileContainer
                                    onClose={() => this.toggleProfile(false)}
                                    navToggle={toggleProfile}
                                />
                            }

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(
    state => {
        const { notification } = state;

        return {
            notification
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, notificationActions),
        dispatch
    )
)(Header);
